import './styles.scss'
import * as React from 'react'
import { connect } from 'react-redux'
// @ts-ignore
import { List } from 'relevant-ui'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { AppState } from 'reducers'
import { withTranslation } from 'react-i18next'
import { Props, State, DispatchProps } from './types'
import {
  getUsersList,
  setCurrentUser,
  createUser,
  updateUser,
  deleteUser,
} from '@App/store/user'
import { getSegmentUser } from '@App/store/segment'
import { getRolesUser, createRole } from '@App/store/role'
import { getOrganizationsUser } from '@App/store/organizations/actions'
import UiPage from '@App/components/blocks/UiPage'
import UserForm from '@App/components/forms/UserForm'
import { toggleFieldAction } from '@App/store/toggleField'
import { getFormValues } from 'redux-form'
import { Fields } from '@App/components/forms/UserForm/types'
import to from 'await-to-js'
import {
  ModalType,
  setShowModal,
  setHideModal,
  ModalSize,
} from '@App/store/modal'
import Modal from '@App/components/blocks/Modal'
import ModalConfirm from '@App/components/blocks/Modal/ModalConfirm'
import { createJob } from '@App/actions/jobs'
import NewJobForm from '@App/components/forms/NewJobForm'
import NewRoleForm from '@App/components/forms/NewRoleForm'

class UsersPage extends React.Component<Props, State> {
  private searchTimeout: ReturnType<typeof setTimeout> | null = null

  static renderCurrentUser(el) {
    return {
      id: el.id,
      title: el.fullName,
      subtitle: el.role?.title,
      email: el.email,
      avatar: el.avatar,
      firstName: el.firstName,
      lastName: el.lastName,
      organization: el.organization,
      job: el.job,
      role: {
        label: el.role?.title,
        value: el.role?.id,
        roleValue: el.role.value,
      },
      networks: el.networks || [],
      app: el.applications,
    }
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      deleteUser: null,
      search: '',
    }

    props.getUsersList()

    this.handleClick = this.handleClick.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.onHandleSubmit = this.onHandleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDeleteUser = this.handleDeleteUser.bind(this)
    this.onJobSubmmit = this.onJobSubmmit.bind(this)
    this.onRoleSubmmit = this.onRoleSubmmit.bind(this)
    this.handleSetCurrentUser = this.handleSetCurrentUser.bind(this)
    this.handleCanceled = this.handleCanceled.bind(this)
  }

  componentDidMount() {
    const {
      users,
      getSegmentsUser,
      getRolesUser,
      getOrganizationsUser,
      setCurrentUser,
    } = this.props

    getSegmentsUser()
    getRolesUser()
    getOrganizationsUser()
    setCurrentUser(users[0] && UsersPage.renderCurrentUser(users[0]))
  }

  async onHandleSubmit(e, data) {
    e.preventDefault()

    const {
      userFormValues,
      createUser,
      updateUser,
      current,
      toggleFieldAction,
    } = this.props

    const body = {
      firstName: userFormValues?.first_name,
      lastName: userFormValues?.last_name,
      email: userFormValues?.email,
      roleId: data?.userRoleValue?.value,
      jobId: userFormValues?.team?.value,
      organizationId: userFormValues?.organization?.value,
      segments: data?.segmentList,
      networks: userFormValues?.networks?.map((el: any) => el.value),
    }

    if (current) {
      const [, res] = await to(updateUser(body, current.id)) as any

      if (res?.user) {
        return toggleFieldAction(true)
      }
      return toggleFieldAction(false)
    }

    const [, res] = await to(createUser(body)) as any

    if (res?.user) {
      return toggleFieldAction(true)
    }
    return toggleFieldAction(false)
  }

  handleClick() {
    const { toggleFieldAction, setCurrentUser } = this.props

    toggleFieldAction(false)
    setCurrentUser(null)
    return
  }

  handleSearch(e) {
    this.setState({ search: e })

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    this.searchTimeout = setTimeout(
      () => {
        this.props.getUsersList(e || undefined)
      },
      300,
    )
  }

  handleDelete(e) {
    e.preventDefault()

    this.setState({ deleteUser: this.props.current.id })
    return this.props.setShowModal(ModalType.DELETE)
  }

  async handleDeleteUser() {
    const { deleteUser, setHideModal, setCurrentUser, users } = this.props

    await deleteUser(this.state.deleteUser)
    setCurrentUser(users[0] && UsersPage.renderCurrentUser(users[0]))

    const search = {
      firstName: {
        $like: `%${this.state.search}%`,
      },
    }
    this.props.getUsersList(search)

    return setHideModal()
  }

  async onJobSubmmit(e, data) {
    e.preventDefault()

    const { createJob, setHideModal, current, setCurrentUser } = this.props

    const [, res] = await to(createJob(data.name))

    setCurrentUser({
      ...current,
      job: res,
    })
    return setHideModal()
  }

  async onRoleSubmmit(e, data) {
    e.preventDefault()

    const { setHideModal, createRole, setCurrentUser, current } = this.props
    const [, res]: any = await to(createRole(data))

    setCurrentUser({
      ...current,
      role: { label: res?.title, value: res?.id },
    })
    return setHideModal()
  }

  handleSetCurrentUser(e) {
    const { setCurrentUser } = this.props

    setCurrentUser(e)
  }

  handleCanceled() {
    const { toggleFieldAction, setCurrentUser, current, users } = this.props

    if (!current) setCurrentUser(users[0] && UsersPage.renderCurrentUser(users[0]))
    toggleFieldAction(true)
  }

  render() {
    const { users, current, setHideModal, t } = this.props

    const userList = users?.map((el: any) => UsersPage.renderCurrentUser(el))

    return (
      <div style={{ height: '100%' }}>
        <UiPage
          title={t('User')}
          button={t('new_user')}
          search={t('search_user')}
          data={userList || []}
          handleClick={this.handleClick}
          handleSearch={(e: any) => this.handleSearch(e.target.value)}
          setCurrent={this.handleSetCurrentUser}
          withHeader
        >
          <UserForm
            handleSubmit={(e: any, data: any) => this.onHandleSubmit(e, data)}
            handleCancel={this.handleCanceled}
            handleDelete={this.handleDelete}
            onRoleSubmmit={this.onRoleSubmmit}
            onJobSubmmit={this.onJobSubmmit}
          />
        </UiPage>
        <Modal
          type={ModalType.DELETE}
          size={ModalSize.SMALL}
          handleClose={() => { }}
        >
          <ModalConfirm
            title="Supprimer l'utilisateur"
            description={`Etes vous sur de vouloir supprimer l'utilisateur: ${current?.title}`}
            handleCancel={setHideModal}
            handleConfirm={this.handleDeleteUser}
          />
        </Modal>
        <Modal
          type={ModalType.FORM}
          size={ModalSize.SMALL}
          handleClose={() => { }}
        >
          <NewJobForm
            onSubmit={(e, data) => this.onJobSubmmit(e, data)}
            canceled={() => setHideModal()}
          />
        </Modal>
        <Modal
          type={ModalType.DEMO}
          size={ModalSize.FIT}
          handleClose={() => { }}
        >
          <NewRoleForm
            onSubmit={(e, data) => this.onRoleSubmmit(e, data)}
            canceled={() => setHideModal()}
          />
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state: AppState) => {
  const userFormValues = getFormValues(Fields.FORM)(state)
  const { users } = state

  return {
    userFormValues,
    ...users,
    current: users.current,
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    getUsersList: (search: string) => dispatch(getUsersList(search)),
    getSegmentsUser: () => dispatch(getSegmentUser()),
    getRolesUser: () => dispatch(getRolesUser()),
    getOrganizationsUser: () => dispatch(getOrganizationsUser()),
    setCurrentUser: (user: any) => dispatch(setCurrentUser(user)),
    toggleFieldAction: (bool: boolean) => dispatch(toggleFieldAction(bool)),
    createUser: (body: any) => dispatch(createUser(body)),
    updateUser: (body: any, id: number) => dispatch(updateUser(body, id)),
    setShowModal: (type: any) => dispatch(setShowModal(type)),
    setHideModal: () => dispatch(setHideModal()),
    deleteUser: (id: number) => dispatch(deleteUser(id)),
    createJob: (name: string) => dispatch(createJob(name)),
    createRole: (data: any) => dispatch(createRole(data)),
  }
}

export default compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(UsersPage)
